import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CDatePicker,
} from '@coreui/react-pro'
import '../../../css/FormDatePicker.css'

const FormDatePicker = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  feedbackInvalid,
  invalid,
  value,
  handleOnDateChange,
  disabled,
  maxDate,
  minDate,
  withTimePicker = false,
  cleaner = true,
  disabledDates = [],
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <CFormLabel className='fs-6 fs-md-3'>
        {inputLabel}
      </CFormLabel>
      <CDatePicker
        locale="en-US" 
        id={id}
        name={name}
        date={value}
        className={`${feedbackInvalid ? 'date_picker_invalid' : ''} fs-6 fs-md-3`}
        onDateChange={(value) => handleOnDateChange(value, name)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid ? true : false}
        disabled={disabled}
        maxDate={maxDate}
        minDate={minDate}
        timepicker={withTimePicker}
        cleaner={cleaner}
        disabledDates={disabledDates}
      />
    </CCol>
  )
}

export default FormDatePicker